module.exports = __webpack_public_path__ + "img/ring-cub.aa7231d1.png";